import { useRecruitmentApi } from 'infrastructure/api';
import type { RecruitmentPool } from './types';

const useRecruitmentPoolPositionFillRequestService = () => {
  const { sendPatchRequest } = useRecruitmentApi();

  const attachPositionFillRequest = async (
    recruitmentPoolId: string,
    positionFillRequestId: string,
  ): Promise<RecruitmentPool> => {
    const response = await sendPatchRequest(
      `/recruitment-pool/${recruitmentPoolId}/position-fill-requests/${positionFillRequestId}/attach`,
    );

    return response.json();
  };

  const detachPositionFillRequest = async (
    recruitmentPoolId: string,
    positionFillRequestId: string,
  ): Promise<RecruitmentPool> => {
    const response = await sendPatchRequest(
      `/recruitment-pool/${recruitmentPoolId}/position-fill-requests/${positionFillRequestId}/detach`,
    );

    return response.json();
  };

  const changePositionFillRequestPool = async (
    positionFillRequestId: string,
    currentRecruitmentPoolId: string,
    nextRecruitmentPoolId: string,
  ) => {
    if (currentRecruitmentPoolId === nextRecruitmentPoolId) return undefined;

    await detachPositionFillRequest(currentRecruitmentPoolId, positionFillRequestId);

    try {
      return await attachPositionFillRequest(nextRecruitmentPoolId, positionFillRequestId);
    } catch (error) {
      await attachPositionFillRequest(currentRecruitmentPoolId, positionFillRequestId);
      throw error;
    }
  };

  return {
    attachPositionFillRequest,
    detachPositionFillRequest,
    changePositionFillRequestPool,
  };
};

export default useRecruitmentPoolPositionFillRequestService;
